module.exports = __webpack_public_path__ + "KaTeX_Script-Regular.2361d9c8.woff";